import { post, get, deletefn, putfun } from './http.js'

export default {
  // 发送消息
  async sendMessage (params) {
    return await post ('/common/chat',params)
  },
  // 私信用户列表
  async chatUserList (params) {
    return await get ('/common/chat',params)
  },
  // 私信详情
  async chatDetail (params) {
    return await get (`/common/chat/${params.id}`,params)
  },
  // 私信用户删除
  async chatUserDelete (params) {
    return await deletefn (`/common/chat/${params}`)
  },
  // 消息设置
  async messageSetting (params) {
      return await putfun('/common/notifications',params)
  },
  // 消息阅读多个
  async notificationReadMore (params) {
    return await putfun('/common/notifications-read',params)
  },
  // 消息阅读全部
  async notificationReadAll(params) {
    return await putfun('/common/notifications-all-read',params)
  },
  // 消息列表
  async notificationType(params) {
    return await get('/common/notifications',params)
  },
}



// WEBPACK FOOTER //
// ./src/request/message.js